import axios from 'axios';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import gs from '../../styles/style';
import { InformationalModal, useModal } from './Modal';
var ErrorResponseHandler = withRouter(function (_a) {
    var history = _a.history;
    var t = useTranslation().t;
    var sessionExpiredModal = useModal({
        onClose: function () {
            window.location.reload();
        }
    });
    var unauthorizedModal = useModal();
    var serverErrorModal = useModal();
    var throttledModal = useModal();
    useEffect(function () {
        var interceptor = axios.interceptors.response.use(function (response) {
            return response;
        }, function (error) {
            var response = error.response;
            if (response) {
                if (response.status === 401 && response.data['require_2fa']) {
                    history.push('/2fa');
                }
                else if (response.status === 401 || response.status === 419) {
                    sessionExpiredModal.open();
                }
                else if (response.status === 403) {
                    unauthorizedModal.open();
                }
                else if (response.status === 422) {
                }
                else if (response.status === 429) {
                    throttledModal.open();
                }
                else {
                    serverErrorModal.open();
                }
            }
            return Promise.reject(error);
        });
        return function () {
            axios.interceptors.response.eject(interceptor);
        };
    }, []);
    return React.createElement(React.Fragment, null,
        React.createElement(InformationalModal, { modal: sessionExpiredModal },
            React.createElement("h5", { className: gs('my-2') }, t('session_expired_description'))),
        React.createElement(InformationalModal, { modal: serverErrorModal },
            React.createElement("h5", { className: gs('my-2') }, t('server_error_description'))),
        React.createElement(InformationalModal, { modal: unauthorizedModal },
            React.createElement("h5", { className: gs('my-2') }, t('unauthorized_description'))),
        React.createElement(InformationalModal, { modal: throttledModal },
            React.createElement("h5", { className: gs('my-2') }, t('throttled_description'))));
});
export default ErrorResponseHandler;
